import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/saas');

export const saas = {
	// 获取用户域名
	getUserDomain(userId) {
		return http.get(`/company-domain/user/${userId}`);
	},
};
